import { computed, Directive, input } from '@angular/core';
import type { InputSignal, Signal } from '@angular/core';

@Directive({
  selector: '[tdWbHide]',
  host: {
    '[attr.aria-hidden]': 'attrHidden()',
    '[class.td-wb-vh]': 'tdWbHide()'
  }
})
export class HideDirective {
  readonly tdWbHide: InputSignal<boolean> = input(false);
  readonly attrHidden: Signal<string> = computed(() => this.tdWbHide() ? 'true' : 'false');
}
